import {httpCore} from "./instance/http";

export const postRatingForm   = params => httpCore.post('callme/rest/rating-form',params);

